'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StandardSidebarContainer from 'ContentEditorUI/components/StandardSidebarContainer';
import SidebarPanelContainer from 'page-editor-ui/containers/SidebarPanelContainer';
import { makeAsyncComponent } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import { getAuth } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getShouldShowInstanceEditingMode } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getActiveSidebarPanel, getSelectedField, getSidebarCategory } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getSelectedRowOrColumn, getSelectedModuleInTree, getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getHasTheme } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getIsStarterPageTemplate } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { getEditSidebarActiveTab } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import PatagoniaAddPanel from 'ContentEditorUI/components/sidebar/PatagoniaAddPanel';
import PatagoniaSidebarContentContainer from 'page-editor-ui/containers/PatagoniaSidebarContentContainer';
import PatagoniaToolsMenu from 'page-editor-ui/containers/PatagoniaToolsContainer';
import PatagoniaXrayPanel from 'ContentEditorUI/components/xray/recommendationPanels/PatagoniaXrayPanel';
import ContentManagement from 'ContentEditorUI/components/contentManagement/ContentManagement';
import { SIDEBAR_PANELS, LAYERS_SIDEBAR_WIDTH, EDIT_MODULE_SIDEBAR_WIDTH, TOOLS_MENU_SIDEBAR_WIDTH, OPTIMIZER_SIDEBAR_WIDTH, PUSHY, PAGE_MANAGEMENT_SIDEBAR_WIDTH, FLOATY } from 'ContentEditorUI/lib/sidebar/constants';
import SidebarContentContainer from 'ContentEditorUI/containers/SidebarContainer';
import { getCurrentTab } from 'ContentEditorUI/redux/selectors/universalNavSelectors';
import { getXrayConfig } from 'page-editor-ui/redux/actions/xrayActionsAndConfig';
import { openPatagoniaModulePanelOnModuleId as openPatagoniaModulePanelOnModuleIdAction } from 'ContentEditorUI/redux/actions/inpageActions';
import { setXrayInpageGathererKeys as setXrayInpageGathererKeysAction } from 'ContentEditorUI/redux/actions/xrayActions';
import { clearQueryParam as clearQueryParamAction, replacePage as replacePageRoutingAction } from 'ContentEditorUI/redux/actions/routingActions';
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { getHasAnyContainerOrDndAreaToAddModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getCanMABExperiment } from 'page-editor-ui/redux/selectors/mabExperimentSelectors';
import { getDefaultAddPanelContentWidth } from 'ContentEditorUI/js/utils/sidebarUtil';
import { parseQueryString } from 'ContentEditorUI/utils/routeHelper';
import { getSidebarSearchQuery } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { getIsUngatedForAiAbLandingPages, getIsUngatedForUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { setActivePatagoniaPanel as setActivePatagoniaPanelAction } from 'ContentEditorUI/redux/actions/panelActions';
import { AiAbTestShepherd } from 'page-editor-ui/components/AiAbTestShepherd';
import { AddIcon, SiteTreeIcon, GaugeIcon, TestIcon, FileIcon, EditIcon, HubDBIcon, StylesIcon } from 'foundations-assets';
import ThemeEditorContainer from 'page-editor-ui/containers/ThemeEditorContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncHubDBContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'HubDBFormEditor' */'ContentEditorUI/containers/hubdb/HubDBFormEditor'));
const AsyncPageDesignSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PageDesignSidebarContainer' */'page-editor-ui/containers/PageDesignSidebarContainer'));
const mapStateToProps = state => ({
  activePanel: getActiveSidebarPanel(state),
  editSidebarActiveTab: getEditSidebarActiveTab(state),
  selectedField: getSelectedField(state),
  selectedModuleInTree: getSelectedModuleInTree(state),
  selectedModuleName: getSelectedModuleName(state),
  selectedRowOrColumn: getSelectedRowOrColumn(state),
  hasAnyContainerOrDndAreaToAddModules: getHasAnyContainerOrDndAreaToAddModules(state),
  currentTab: getCurrentTab(state),
  selectedSidebarCategory: getSidebarCategory(state),
  showInlineDataTokenEditing: getShouldShowInstanceEditingMode(state),
  xrayConfigFromEditor: getXrayConfig(getAuth(state)),
  canMABExperiment: getCanMABExperiment(state),
  categorizedSearchQuery: getSidebarSearchQuery(state),
  hasTheme: getHasTheme(state),
  isStarterPageTemplate: getIsStarterPageTemplate(state),
  isUngatedForAiAbLandingPages: getIsUngatedForAiAbLandingPages(state),
  currentRoutingPathname: getRoutingCurrentPage(state),
  isUngatedForUniversalThemeEditor: getIsUngatedForUniversalThemeEditor(state)
});
const mapDispatchToProps = {
  setXrayInpageGathererKeys: setXrayInpageGathererKeysAction,
  openPatagoniaModulePanelOnModuleId: openPatagoniaModulePanelOnModuleIdAction,
  clearQueryParam: clearQueryParamAction,
  setActivePatagoniaPanel: setActivePatagoniaPanelAction,
  replaceRoutingPathname: replacePageRoutingAction
};
class SidebarContainer extends Component {
  componentDidMount() {
    const {
      xrayConfigFromEditor,
      setXrayInpageGathererKeys,
      location,
      clearQueryParam,
      hasAnyContainerOrDndAreaToAddModules,
      openPatagoniaModulePanelOnModuleId,
      setActivePatagoniaPanel,
      currentRoutingPathname,
      replaceRoutingPathname
    } = this.props;
    setXrayInpageGathererKeys(xrayConfigFromEditor);
    const {
      moduleSchemaId
    } = parseQueryString(location.search);
    if (moduleSchemaId) {
      if (hasAnyContainerOrDndAreaToAddModules) {
        openPatagoniaModulePanelOnModuleId(Number(moduleSchemaId));
      }
      clearQueryParam('moduleSchemaId');
    } else if (currentRoutingPathname === 'test') {
      setActivePatagoniaPanel(SIDEBAR_PANELS.tools);
      // Replace `/test` with `/content` so we always end up back on the "main" path ('/content')
      replaceRoutingPathname('content');
    }
  }
  sidebarOptions() {
    const {
      selectedSidebarCategory,
      showInlineDataTokenEditing,
      xrayConfigFromEditor,
      hasAnyContainerOrDndAreaToAddModules,
      canMABExperiment,
      categorizedSearchQuery,
      hasTheme,
      isStarterPageTemplate,
      isUngatedForUniversalThemeEditor
    } = this.props;
    const tooltipLabel = 'patagonia.sidebar.tooltipLabel';
    const addButtonTooltipKey = !hasAnyContainerOrDndAreaToAddModules ? 'sidebar.tabs.add.disabled.patagoniaMessage' : 'patagonia.sidebar.tooltipLabel.add';
    const shouldShowDesignIcon = hasTheme && (isUngatedForUniversalThemeEditor || isStarterPageTemplate);
    return [{
      type: 'panel',
      iconName: 'add',
      iconNode: AddIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: addButtonTooltipKey
      }),
      disabled: !hasAnyContainerOrDndAreaToAddModules,
      panelName: SIDEBAR_PANELS.addWidget,
      content: /*#__PURE__*/_jsx(PatagoniaAddPanel, {}),
      contentWidth: getDefaultAddPanelContentWidth(selectedSidebarCategory, categorizedSearchQuery),
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'siteTree',
      iconNode: SiteTreeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.pageContents,
      content: /*#__PURE__*/_jsx(PatagoniaSidebarContentContainer, {}),
      contentWidth: LAYERS_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'gauge',
      iconNode: GaugeIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.optimizer`
      }),
      panelName: SIDEBAR_PANELS.optimizer,
      content: /*#__PURE__*/_jsx(PatagoniaXrayPanel, {
        config: xrayConfigFromEditor
      }),
      contentWidth: OPTIMIZER_SIDEBAR_WIDTH,
      hideItem: false,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'test',
      iconNode: TestIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.test`
      }),
      panelName: SIDEBAR_PANELS.tools,
      content: /*#__PURE__*/_jsx(PatagoniaToolsMenu, {}),
      contentWidth: TOOLS_MENU_SIDEBAR_WIDTH,
      hideItem: !canMABExperiment,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'separator'
    }, {
      type: 'panel',
      iconName: 'file',
      iconNode: FileIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageManagement`
      }),
      panelName: SIDEBAR_PANELS.pageManagement,
      content: /*#__PURE__*/_jsx(ContentManagement, {}),
      contentWidth: PAGE_MANAGEMENT_SIDEBAR_WIDTH,
      hideItem: false,
      panelDisplay: {
        type: FLOATY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'edit',
      iconNode: EditIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${tooltipLabel}.pageContents`
      }),
      panelName: SIDEBAR_PANELS.edit,
      content: this.renderSidebarContainer(),
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      hideItem: true,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }, {
      type: 'instance-editing',
      iconName: 'hubDB',
      iconNode: HubDBIcon,
      tooltipLabel: 'Hub DB Instance Editing',
      panelName: SIDEBAR_PANELS.instanceEditing,
      content: /*#__PURE__*/_jsx(AsyncHubDBContainer, {}),
      hideItem: !showInlineDataTokenEditing,
      contentWidth: 400,
      panelDisplay: {
        type: PUSHY,
        showScroll: false
      }
    }, {
      type: 'panel',
      iconName: 'styles',
      iconNode: StylesIcon,
      tooltipLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "sidebar.tabs.design.title"
      }),
      panelName: SIDEBAR_PANELS.design,
      content: isUngatedForUniversalThemeEditor ? /*#__PURE__*/_jsx(ThemeEditorContainer, {}) : /*#__PURE__*/_jsx(AsyncPageDesignSidebarContainer, {}),
      hideItem: !shouldShowDesignIcon,
      contentWidth: EDIT_MODULE_SIDEBAR_WIDTH,
      panelDisplay: {
        type: PUSHY,
        showScroll: true
      }
    }];
  }
  renderSidebarPanelContainer() {
    const {
      activePanel,
      editSidebarActiveTab,
      selectedField,
      selectedModuleInTree,
      selectedModuleName,
      selectedRowOrColumn
    } = this.props;
    return /*#__PURE__*/_jsx(SidebarPanelContainer, {
      panelName: activePanel,
      selectedRowOrColumn: selectedRowOrColumn,
      selectedModuleInTree: selectedModuleInTree,
      selectedModuleName: selectedModuleName,
      editSidebarActiveTab: editSidebarActiveTab,
      selectedField: selectedField,
      showDeviceToggle: true
    });
  }
  renderSidebarContainer() {
    const {
      currentTab,
      showDeviceToggle,
      activePanel,
      editSidebarActiveTab,
      selectedField,
      selectedModuleInTree,
      selectedModuleName,
      selectedRowOrColumn
    } = this.props;
    return /*#__PURE__*/_jsx(SidebarContentContainer, {
      currentTab: currentTab,
      showDeviceToggle: showDeviceToggle,
      children: /*#__PURE__*/_jsx(SidebarPanelContainer, {
        panelName: activePanel,
        selectedRowOrColumn: selectedRowOrColumn,
        selectedModuleInTree: selectedModuleInTree,
        selectedModuleName: selectedModuleName,
        editSidebarActiveTab: editSidebarActiveTab,
        selectedField: selectedField,
        showDeviceToggle: true
      })
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(StandardSidebarContainer, {
        sidebarOptions: this.sidebarOptions(),
        children: this.renderSidebarPanelContainer()
      }), /*#__PURE__*/_jsx(AiAbTestShepherd, {})]
    });
  }
}
SidebarContainer.propTypes = {
  activePanel: PropTypes.string.isRequired,
  editSidebarActiveTab: PropTypes.string,
  selectedField: PropTypes.object,
  selectedModuleInTree: PropTypes.object,
  selectedModuleName: PropTypes.string,
  selectedRowOrColumn: PropTypes.object,
  currentTab: PropTypes.object.isRequired,
  showDeviceToggle: PropTypes.bool,
  selectedSidebarCategory: PropTypes.string.isRequired,
  hasAnyContainerOrDndAreaToAddModules: PropTypes.bool.isRequired,
  showInlineDataTokenEditing: PropTypes.bool,
  location: PropTypes.object,
  xrayConfigFromEditor: PropTypes.object.isRequired,
  setXrayInpageGathererKeys: PropTypes.func.isRequired,
  openPatagoniaModulePanelOnModuleId: PropTypes.func.isRequired,
  clearQueryParam: PropTypes.func.isRequired,
  canMABExperiment: PropTypes.bool,
  categorizedSearchQuery: PropTypes.string,
  hasTheme: PropTypes.bool.isRequired,
  isStarterPageTemplate: PropTypes.bool.isRequired,
  setActivePatagoniaPanel: PropTypes.func.isRequired,
  currentRoutingPathname: PropTypes.string.isRequired,
  replaceRoutingPathname: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SidebarContainer));